module.exports = {"id":"220209","name":"Kemar Lawrence","rating":"72","photo":"./data/images/photos/3/220209.png","club":{"name":"NY Red Bulls","logo":"./data/images/clubs/NYRedBulls.png"},"positions":["DG","DLG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KemarLawrence0.json
// module id = 2317
// module chunks = 0